export enum FilterVehicleType {
    Status = 1,
    Group = 2,
    Blocking = 3,
    TachoStatus = 4,
    MultipleCheckbox = 5,
}

export enum FilterLockType {
    Unblock = 1,
    Lock = 2,
}